import { Show, onMount } from "solid-js";
import { HorizontalScrollerGradient } from "./HorizontalScroller";
import { twMerge } from "tailwind-merge";

const ColorPill = (props) => {
  return (
    <li
      ref={props.ref}
      id={`swatch-${props.id}`}
      class={`horizontal-scroller-slide`}
      data-spv={props.salesPerView}
      classList={{
        'active': props.isSelected
      }}
      onclick={() => props.colorSelectionHandler(props.id)}>
      <span class="swatch">
        <div class="relative">
          <img src={`${props.src}&width=16&height=16&crop=center`}
            data-srcset={props.srcSet}
            class={`!h-4 !w-4 !rounded-lg ${(props.isOutOfStock && !props.isSelected) ? 'opacity-60' : ''}`}
            width="auto"
            height="auto" data-sizes="auto" alt={props.label} loading="lazy" />
          <Show when={props.isOutOfStock}>
            <div class={`absolute w-full h-full top-0 left-0 right-0 bottom-0 overflow-x-hidden rounded-lg ${props.isSelected ? 'text-ink' : 'text-canvas'}`}>
              <svg class="w-full h-full" fill="none" viewBox="0 0 32 32">
                <line y1="0" stroke="currentColor" stroke-width="2" y2="32" x2="0" x1="32"></line>
              </svg>
            </div>
          </Show>
        </div>
      </span>
      <span class="color-name text-secondary-800">{props.label}</span>
    </li>
  )
}

export const ColorSelector = (props) => {
  const selectedColor = () => props.selected;
  const options = () => props.options;
  const selectedOption = () => options().find(option => option.id == selectedColor());
  const centerColorPill = (colorId) => {
    const elem = document.getElementById(`swatch-${colorId}`);
    const parentElem = elem.parentElement;

    const rect = elem.getBoundingClientRect();
    const parentRect = parentElem.getBoundingClientRect();

    const scrollLeft = rect.left - parentRect.left + parentElem.scrollLeft;
    const scrollCenter = scrollLeft - parentElem.clientWidth / 2 + rect.width / 2;

    setTimeout(() => {
      parentElem.scrollTo({
        left: scrollCenter,
        behavior: 'smooth'
      })
    }, 600);
  }

  const colorSelectionHandler = (colorOptionId) => {
    props.handleSelection(colorOptionId);

    centerColorPill(colorOptionId);
  }

  onMount(() => {
    centerColorPill(selectedColor());
  })

  const colorPills = () => options()
    .sort((a, b) => a.salesPerView - b.salesPerView).reverse()
    .map((colorOption) => {
      const isSelected = () => colorOption.id == selectedColor();
      const isOutOfStock = () => colorOption.isOutOfStock;
      const src = colorOption.swatchImages.src;
      const srcSet = [34, 49, 58, 68, 102, 116, 174].map(width => `${src}width=${width}&height=${width}&crop=center ${width}w`).join(', ');

      return {
        component: ColorPill,
        props: {
          id: colorOption.id,
          isSelected: isSelected(),
          label: colorOption.label,
          src,
          srcSet,
          isOutOfStock: isOutOfStock(),
          salesPerView: colorOption.salesPerView,
          colorSelectionHandler
        }
      }
    })

  return (
    <div id="phcf-current-product-colors"
      class={twMerge(
        `flex flex-col justify-center scroll-mt-9 items-start font-bold uppercase border-t-outer w-full py-0.5  sm:items-center`,
        props.class ?? ''
      )}
    >
      <span class="hidden font-medium text-left">Color</span>
      <HorizontalScrollerGradient
        wrapper="ul"
        wrapperClass={`horizontal-scroller-wrapper scrollbar-hide product-hero-swatches pb-1  sm:p-0 max-w-full !flex-wrap !overflow-visible px-2 sm:px-6`}
        parentClass=""
        slides={colorPills()}
        scrollMultiplier={0.5}
        hideArrows={true}
      />
      <span
        class="font-regular normal-case w-full sm:text-left px-2 sm:pr-6 sm:pb-0 sm:pt-2 text-xs sm:text-sm"
        classList={{
          "order-first": true
        }}
      >
        <span classList={{
          "font-bold text-sm md:text-base": true
        }}>Color: </span>
        <span classList={{
          "font-normal": true
        }}>{selectedOption().label}</span>
        <Show when={selectedOption().isOutOfStock == true}>
          <div class="text-base sm:text-[18px] normal-case text-secondary-accent font-bold">Sold Out</div>
        </Show>
      </span>
    </div>
  )
}